import { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import saurabh_img from "../assets/saurabh_img.jpg"

/* ============================================================
   TEAM MEMBER PAGE  (img with SVG portrait fallback)
   ------------------------------------------------------------
   Every member has an "image" field.
   - If image URL exists  -> real photo is shown
   - If image is "" OR the URL fails to load -> animated SVG
     executive portrait silhouette is shown automatically
   ============================================================ */

// /* ---------------- DATA ---------------- */
// const secretariat = [
//   { name: "Mr. Saurabh Sanyal", designation: "Secretary General, ASSOCHAM", image: saurabh_img },
//   { name: "Mr. D.S. Rajora", designation: "Deputy Secretary General", image: "https://assocham.org/assocham_backend/assets/images/DSG.jpeg" },
//   { name: "Mr. Harish Sharma", designation: "Assistant Secretary General/CFO", image: "https://assocham.org/assocham_backend/assets/images/Harish.jpg" },
//   { name: "Mr. Basudev Mukherjee", designation: "Assistant Secretary General", image: "https://assocham.org/assocham_backend/assets/images/Basudev.jpg" },
//   { name: "Dr. Ambika Sharma", designation: "Assistant Secretary General", image: "https://assocham.org/assocham_backend/assets/images/Ambika.jpg" },
//   { name: "Dr. S.P. Sharma", designation: "Chief Economist", image: "/OurTeam/S_P_Sharma.jpg" },
//   { name: "Ms. Perminder Kaur", designation: "Senior Director - Head States & UTs", image: "https://assocham.org/assocham_backend/images/awards/image1.png" },
//   { name: "Ms. Manju Negi", designation: "Senior Director", image: "https://assocham.org/assocham_backend/images/awards/img2.png" },
//   { name: "Ms. Deepti Pant", designation: "Senior Director", image: "https://assocham.org/assocham_backend/images/awards/img4.png" },
//   { name: "Mr. Varun Aggarwal", designation: "Senior Director", image: "https://assocham.org/assocham_backend/images/awards/img3.png" },
//   { name: "Mr. Avinash Sharma", designation: "Senior Director", image: "/OurTeam/AvinashSharma.png" },
//   { name: "Ms. Kavita Sharma", designation: "Director", image: "https://assocham.org/assocham_backend/images/awards/img6.png" },
//   { name: "Ms. Mili Chadha", designation: "Director", image: "https://assocham.org/assocham_backend/images/awards/img7.png" },
//   { name: "Mr. Jaidev Sharma", designation: "Director", image: "/OurTeam/JaidevSharma.png" },
//   { name: "Mr. Suresh Chandra Joshi", designation: "Additional Director", image: "/OurTeam/SureshChandra.png" },
//   { name: "Mr. Ankit Raghav", designation: "Additional Director", image: "OurTeam/AnkitRaghav.jpg" },
//   { name: "Mr. Abhay Yadav", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img20.png" },
//   { name: "Ms. Tanuja Adhikari", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/Tanuja-Adhikari.jpeg" },
//   { name: "Ms. Alankrita Soni", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img12.png" },
//   { name: "Mr. Raj", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img9.png" },
//   { name: "Dr. Swati Sharma", designation: "Additional Director", image: "/OurTeam/SwatiSharma.jpg" },
//   { name: "Mr. Manveen Singh Chadha", designation: "Additional Director", image: "OurTeam/ManveenSinghChadha.jpg" },
//   { name: "Ms. Ruchi Singhal", designation: "Additional Director", image: "/OurTeam/RuchiSinghal.png" },
//   { name: "Ms. Yatika Gupta", designation: "Joint Director", image: "https://assocham.org/assocham_backend/images/awards/img14.png" },
//   { name: "Ms. Sunita Prajapati", designation: "Joint Director", image: "/OurTeam/SunitaPrajapati.jpg" },
//   { name: "Ms. Sumita Sharma", designation: "Joint Director", image: "https://assocham.org/assocham_backend/images/awards/img13.png" },
//   { name: "Mr. Ram Kumar Vijayan", designation: "Head - Tourism", image: "/OurTeam/Ramkumar_Vijayan.jpg" },
// ].map((m, i) => ({ ...m, id: `sec-${i}`, category: "Secretariat" }));

// const stateReps = [
//   { name: "Ms. Perminder Kaur", designation: "Senior Director - Head States & UTs", image: "https://assocham.org/assocham_backend/images/awards/image1.png" },
//   { name: "Ms. Uma S Nair", designation: "Regional Head - Karnataka, Tamil Nadu & Kerala", image: "OurTeam/UmaSNair.jpeg" },
//   { name: "Mr. Vipul B G", designation: "Regional Head - Gujarat & Madhya Pradesh", image: "" },
//   { name: "Mr. Macha Dinesh Babu", designation: "Regional Head - Hyderabad & Telangana", image: "" },
//   { name: "Ms. Darshana Kossambe", designation: "State Head - Goa", image: "" },
//   { name: "Mr. Dinesh Mathur", designation: "State Head - Rajasthan", image: "" },
//   { name: "Mr. Priyabrata Mishra", designation: "State Head - Odisha", image: "" },
//   { name: "Mr. Bibhuti Dutta", designation: "State Head - Assam", image: "OurTeam/BibhutiPhoto.jpeg" },
//   { name: "Mr. Ramit Sicar", designation: "State Head - West Bengal", image: "" },
//   { name: "Mr. Rajeev Dixit", designation: "State Head - Uttar Pradesh", image: "" },
//   { name: "Mr. Suresh Babu Ranjan", designation: "State Head - Tamil Nadu", image: "" },
//   { name: "Mr. Robin M.S Rosario", designation: "State Head - Maharashtra", image: "" },
// ].map((m, i) => ({ ...m, id: `rep-${i}`, category: "State Representative" }));


/* ---------------- DATA ---------------- */
const secretariat = [
  { name: "Mr. D.S. Rajora", designation: "Deputy Secretary General", image: "https://assocham.org/assocham_backend/assets/images/DSG.jpeg" },
  { name: "Mr. Harish Sharma", designation: "Assistant Secretary General/CFO", image: "https://assocham.org/assocham_backend/assets/images/Harish.jpg" },
  { name: "Mr. Basudev Mukherjee", designation: "Assistant Secretary General", image: "https://assocham.org/assocham_backend/assets/images/Basudev.jpg" },
  { name: "Dr. Ambika Sharma", designation: "Assistant Secretary General", image: "https://assocham.org/assocham_backend/assets/images/Ambika.jpg" },
  { name: "Dr. S.P. Sharma", designation: "Chief Economist", image: "/OurTeam/S_P_Sharma.jpg" },
  { name: "Ms. Perminder Kaur", designation: "Senior Director - Head States & UTs", image: "https://assocham.org/assocham_backend/images/awards/image1.png" },
  { name: "Ms. Manju Negi", designation: "Senior Director", image: "https://assocham.org/assocham_backend/images/awards/img2.png" },
  { name: "Mr. Varun Aggarwal", designation: "Senior Director", image: "https://assocham.org/assocham_backend/images/awards/img3.png" },
  { name: "Mr. Avinash Sharma", designation: "Senior Director", image: "/OurTeam/AvinashSharma.png" },
  { name: "Mr. Santosh Mathew", designation: "Senior Director", image: "/OurTeam/SantoshMathewphoto.jpg" },
  { name: "Ms. Kavita Sharma", designation: "Director", image: "https://assocham.org/assocham_backend/images/awards/img6.png" },
  { name: "Mr. Jaidev Sharma", designation: "Director", image: "/OurTeam/JaidevSharma.png" },
  { name: "Ms. Mili Chadha", designation: "Director", image: "https://assocham.org/assocham_backend/images/awards/img7.png" },
  { name: "Mr. Suresh Chandra Joshi", designation: "Additional Director", image: "/OurTeam/SureshJoshi.jpeg" },
  { name: "Mr. Ankit Raghav", designation: "Additional Director", image: "OurTeam/AnkitRaghav.jpg" },
  { name: "Mr. Abhay Yadav", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img20.png" },
  { name: "Ms. Tanuja Adhikari", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/Tanuja-Adhikari.jpeg" },
  { name: "Ms. Alankrita Soni", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img12.png" },
  { name: "Mr. Raj", designation: "Additional Director", image: "https://assocham.org/assocham_backend/images/awards/img9.png" },
  { name: "Dr. Swati Sharma", designation: "Additional Director", image: "/OurTeam/SwatiSharma.jpg" },
  { name: "Mr. Manveen Singh Chadha", designation: "Additional Director", image: "OurTeam/ManveenSinghChadha.jpg" },
  { name: "Ms. Ruchi Singhal", designation: "Additional Director", image: "/OurTeam/RuchiSinghal.png" },
  { name: "Ms. Apurva Babbr", designation: "Additional Director -AFCSR", image: "/OurTeam/ApurvaBabbr_photo.JPG" },
  { name: "Ms. Yatika Gupta", designation: "Joint Director", image: "https://assocham.org/assocham_backend/images/awards/img14.png" },
  { name: "Ms. Sunita Prajapati", designation: "Joint Director", image: "/OurTeam/SunitaPrajapati.jpg" },
  { name: "Ms. Sumita Sharma", designation: "Joint Director", image: "https://assocham.org/assocham_backend/images/awards/img13.png" },
  { name: "Mr. Ramkumar Vijayan", designation: "Head - Tourism, Branding and Marketing", image: "/OurTeam/Ramkumar_Vijayan.jpg" },
].map((m, i) => ({ ...m, id: `sec-${i+1}`, category: "Secretariat" }));

const stateReps = [
  
  { name: "Ms. Uma S Nair", designation: "Regional Head - Karnataka, Tamil Nadu & Kerala", image: "OurTeam/UmaSNair.jpeg" },
  { name: "Mr. Vipul B G", designation: "Regional Head - Gujarat & Madhya Pradesh", image: "OurTeam/VipulBG.jpg" },
  { name: "Mr. Macha Dinesh Babu", designation: "Regional Head – Andhra Pradesh & Telangana", image: "OurTeam/MachaDineshBabu.jpg" },
  { name: "Ms. Bharti Sood", designation: "Regional Director", image: "OurTeam/BhartiSood.jpg" },
  { name: "Mr. Robin M.S Rosario", designation: "State Head - Maharashtra", image: "OurTeam/RobinRosario.jpg" },
  { name: "Ms. Darshana Kossambe", designation: "State Head - Goa", image: "OurTeam/DarshanaKossambe.jpg" },

  { name: "Mr. Dinesh Mathur", designation: "State Head - Rajasthan", image: "OurTeam/DineshMathur.jpg" },
  { name: "Mr. Priyabrata Mishra", designation: "State Head - Odisha", image: "OurTeam/PriyabrataMishra.jpeg" },
  { name: "Mr. Bibhuti Dutta", designation: "State Head - Assam", image: "OurTeam/BibhutiPhoto.jpeg" },
  { name: "Mr. Ramit Sicar", designation: "State Head - West Bengal", image: "OurTeam/RamitSicar.jpg" },
  { name: "Mr. Rajeev Dixit", designation: "State Head - Uttar Pradesh", image: "OurTeam/RajeevDixit.jpg" },
  { name: "Mr. Suresh Babu Ranjan", designation: "State Head - Tamil Nadu", image: "OurTeam/SureshBabuRajendran.jpg" },
].map((m, i) => ({ ...m, id: `rep-${i+1}`, category: "State Representative" }));

/* ---------------- HELPERS ---------------- */
const isFemale = (m) =>
  m.name.startsWith("Ms") ||
  m.name.startsWith("Mrs") ||
  m.name.includes("Ambika") ||
  m.name.includes("Swati");

const getBio = (m) =>
  m.category === "Secretariat"
    ? `${m.name} serves as ${m.designation} in the Secretariat, playing a pivotal role in driving the organisation's strategic initiatives, policy advocacy and day-to-day operations. With a strong commitment to excellence, ${isFemale(m) ? "she" : "he"} works closely with stakeholders across industry and government to strengthen the organisation's mission.`
    : `${m.name} serves as ${m.designation}, representing the organisation at the state and regional level. ${isFemale(m) ? "She" : "He"} works closely with local industry, entrepreneurs and government bodies to expand outreach, foster partnerships and support regional economic growth.`;

/* ---------------- SVG FALLBACK PORTRAIT ---------------- */
function SilhouettePortrait({ member }) {
  const female = isFemale(member);
  const gradId = female ? "tmGradF" : "tmGradM";
  return (
    <div
      className="relative flex h-full w-full items-end justify-center overflow-hidden rounded-full"
      style={{ background: "linear-gradient(160deg, #F3ECE2 0%, #EFE0CB 55%, #E8D2B4 100%)" }}
    >
      <svg viewBox="0 0 100 100" className="h-[92%] w-[92%] translate-y-[8%]" aria-hidden="true">
        <defs>
          <linearGradient id="tmGradM" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#DA2128" />
            <stop offset="100%" stopColor="#EE8202" />
          </linearGradient>
          <linearGradient id="tmGradF" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#EE8202" />
            <stop offset="100%" stopColor="#DA2128" />
          </linearGradient>
        </defs>

        {female ? (
          <>
            {/* hair behind */}
            <path
              d="M50 14c-14 0-22 10-22 24 0 10-2 20-6 26h56c-4-6-6-16-6-26 0-14-8-24-22-24z"
              fill={`url(#${gradId})`}
              opacity="0.55"
            />
            {/* head */}
            <circle cx="50" cy="36" r="16" fill={`url(#${gradId})`} />
            {/* shoulders */}
            <path d="M50 56c-19 0-31 12-33 30v14h66V86c-2-18-14-30-33-30z" fill={`url(#${gradId})`} />
            {/* collar */}
            <path d="M43 58l7 9 7-9c-2.2-1.3-4.6-2-7-2s-4.8.7-7 2z" fill="#FFFFFF" opacity="0.9" />
          </>
        ) : (
          <>
            {/* head */}
            <circle cx="50" cy="36" r="18" fill={`url(#${gradId})`} />
            {/* shoulders / suit */}
            <path d="M50 56c-19 0-31 12-33 30v14h66V86c-2-18-14-30-33-30z" fill={`url(#${gradId})`} />
            {/* collar */}
            <path d="M42 58l8 10 8-10c-2.5-1.4-5.2-2-8-2s-5.5.6-8 2z" fill="#FFFFFF" opacity="0.9" />
            {/* tie */}
            <path d="M50 68l-3.4 6 3.4 18 3.4-18z" fill="#B8181E" />
          </>
        )}
      </svg>
    </div>
  );
}

/* ---------------- AVATAR (img OR svg fallback) ---------------- */
function Avatar({ member, size = "lg" }) {
  const [imgError, setImgError] = useState(false);
  const hasImage = member.image && member.image.trim() !== "" && !imgError;

  const dims =
    size === "lg" ? "h-32 w-32 sm:h-36 sm:w-36" : "h-24 w-24";

  return (
    <div className={`avatar-ring relative rounded-full p-[3px] ${dims}`}>
      <div className="flex h-full w-full items-center justify-center rounded-full bg-white p-[5px]">
        {hasImage ? (
          /* ---- real photo ---- */
          <img
            src={member.image}
            alt={member.name}
            loading="lazy"
            onError={() => setImgError(true)}
            className="h-full w-full rounded-full object-cover object-top"
          />
        ) : (
          /* ---- svg fallback portrait ---- */
          <SilhouettePortrait member={member} />
        )}
      </div>
    </div>
  );
}

/* ---------------- CARD ---------------- */
function MemberCard({ member, index, onView }) {
  return (
    <div
      className="member-card group relative flex flex-col items-center rounded-2xl bg-white px-5 pb-7 pt-9 text-center shadow-[0_4px_20px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(218,33,40,0.18)]"
      style={{ animationDelay: `${(index % 12) * 60}ms` }}
    >
      {/* animated top accent bar */}
      <span className="absolute inset-x-0 top-0 h-1.5 origin-left scale-x-0 rounded-t-2xl bg-gradient-to-r from-[#DA2128] to-[#EE8202] transition-transform duration-500 group-hover:scale-x-100" />

      {/* avatar with hover zoom */}
      <div className="transition-transform duration-500 group-hover:scale-105">
        <Avatar member={member} />
      </div>

      <h3 className="mt-5 text-base font-bold text-gray-800 transition-colors duration-300 group-hover:text-[#DA2128]">
        {member.name}
      </h3>
      <p className="mt-1.5 min-h-[40px] text-sm leading-snug text-gray-500">
        {member.designation}
      </p>

      {/* view more */}
      {/* <button
        onClick={() => onView(member)}
        className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#DA2128] transition-all duration-300 hover:gap-2.5 hover:text-[#EE8202]"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#EE8202] text-white transition-transform duration-500 group-hover:rotate-90">
          <svg viewBox="0 0 24 24" className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
        </span>
        View more
      </button> */}
    </div>
  );
}

/* ---------------- MODAL ---------------- */
function MemberModal({ member, onClose }) {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 280);
  };

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && handleClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, []);

  if (!member) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${closing ? "backdrop-out" : "backdrop-in"}`}
      style={{ background: "rgba(30,15,10,0.55)", backdropFilter: "blur(6px)" }}
      onClick={handleClose}
    >
      <div
        className={`relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl ${closing ? "modal-out" : "modal-in"}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* header band */}
        <div className="relative h-28 bg-gradient-to-r from-[#DA2128] via-[#E55415] to-[#EE8202]">
          <div className="absolute -bottom-16 left-1/2 -translate-x-1/2">
            <div className="modal-avatar">
              <Avatar member={member} size="md" />
            </div>
          </div>
          {/* decorative circles */}
          <span className="absolute -left-6 -top-6 h-24 w-24 rounded-full bg-white/10" />
          <span className="absolute right-10 top-4 h-10 w-10 rounded-full bg-white/10" />
          <span className="absolute bottom-3 left-1/4 h-6 w-6 rounded-full bg-white/10" />

          {/* X close */}
          <button
            onClick={handleClose}
            aria-label="Close"
            className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/20 text-white backdrop-blur transition-all duration-300 hover:rotate-90 hover:bg-white hover:text-[#DA2128]"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div className="px-8 pb-8 pt-20 text-center">
          <span className="inline-block rounded-full bg-[#F3ECE2] px-4 py-1 text-xs font-bold uppercase tracking-wider text-[#EE8202]">
            {member.category}
          </span>
          <h2 className="mt-3 text-2xl font-extrabold text-gray-800">{member.name}</h2>
          <p className="mt-1 font-semibold text-[#DA2128]">{member.designation}</p>

          <div className="mx-auto mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-[#DA2128] to-[#EE8202]" />

          <p className="mt-5 text-sm leading-relaxed text-gray-600">{getBio(member)}</p>

          <button
            onClick={handleClose}
            className="mt-7 rounded-full bg-gradient-to-r from-[#DA2128] to-[#EE8202] px-8 py-2.5 text-sm font-bold text-white shadow-lg shadow-orange-200 transition-all duration-300 hover:scale-105 hover:shadow-xl active:scale-95"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------------- SECTION HEADING ---------------- */
function SectionHeading({ label, count }) {
  return (
    <div className="mb-10 flex items-center gap-4">
      <span className="h-10 w-1.5 rounded-full bg-gradient-to-b from-[#DA2128] to-[#EE8202]" />
      <div>
        <h2 className="text-2xl font-extrabold uppercase tracking-wide text-gray-800 sm:text-3xl">
          {label}
        </h2>
        {/* <p className="mt-0.5 text-sm font-medium text-[#EE8202]">{count} Members</p> */}
      </div>
      <span className="ml-2 hidden h-px flex-1 bg-gradient-to-r from-[#EE8202]/40 to-transparent sm:block" />
    </div>
  );
}

/* ---------------- BREADCRUMB ---------------- */
function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white shadow-lg backdrop-blur-md sm:text-sm">
        <li>
          <a href="#" className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#F3ECE2]">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li>
          <a href="#" className="transition-colors duration-300 hover:text-[#F3ECE2]">About</a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li className="rounded-full bg-white px-3 py-1 text-[#DA2128] shadow-sm">Our Team</li>
      </ol>
    </nav>
  );
}


/* ---------------- MAIN COMPONENT ---------------- */
export default function TeamMember() {
  const [activeTab, setActiveTab] = useState("secretariat");
  const [selected, setSelected] = useState(null);

  const tabs = [
    { key: "secretariat", label: "Secretariat", data: secretariat },
    { key: "state", label: "State Representatives", data: stateReps },
  ];
  const active = tabs.find((t) => t.key === activeTab);

  return (
     <div className="min-h-screen bg-[#F3ECE2]">
      {/* ---------- HERO ---------- */}
      <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#E04A1A] to-[#EE8202] py-16 text-center text-white sm:py-20">
        <Breadcrumb />
        <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
        <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
        <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
        <div className="hero-in relative mx-auto max-w-3xl px-4">
          <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
            Meet the people behind our mission
          </p>
          <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
            ASSOCHAM Team
          </h1>
          <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
          {/* <p className="mx-auto mt-5 max-w-xl text-sm text-white/85 sm:text-base">
            A dedicated team of professionals across the Secretariat and States,
            working together to drive growth, policy and partnerships.
          </p> */}
        </div>
      </header>

      {/* ---------- TABS ---------- */}
      <div className="sticky top-[56px] z-40 border-b border-[#EE8202]/20 bg-[#F3ECE2]/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl justify-center gap-3 px-4 py-4">
          {tabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setActiveTab(t.key)}
              className={`rounded-full px-6 py-2.5 text-sm font-bold transition-all duration-300 sm:text-base ${
                activeTab === t.key
                  ? "scale-105 bg-gradient-to-r from-[#DA2128] to-[#EE8202] text-white shadow-lg shadow-orange-300/50"
                  : "bg-white text-gray-600 shadow hover:text-[#DA2128] hover:shadow-md"
              }`}
            >
              {t.label}
              {/* <span
                className={`ml-2 rounded-full px-2 py-0.5 text-xs ${
                  activeTab === t.key ? "bg-white/25" : "bg-[#F3ECE2] text-[#EE8202]"
                }`}
              >
                {t.data.length}
              </span> */}
            </button>
          ))}
        </div>
      </div>

      {/* ---------- GRID ---------- */}
      <main className="mx-auto max-w-6xl px-4 py-12 sm:py-16">
        <div key={activeTab}>
          <SectionHeading label={active.label}  />
          <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {active.data.map((m, i) => (
              <MemberCard key={m.id} member={m} index={i} onView={setSelected} />
            ))}
          </div>
        </div>
      </main>


      {/* ---------- MODAL ---------- */}
      {selected && <MemberModal member={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
